export default __webpack_public_path__ + "static/no-logo-deal-38c7110ed9ff37e93e78815b5a37ddcf.png";